/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：684__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widgetName: "通讯录",
    contactName: "名称",
    phoneNumber: "号码",
    phoneNumberList: "号码列表",
    phoneNumberListTooltip: "列表类型，返回选择的联系人的号码列表。\n如果联系人只有一个号码，则返回一个只有一项的列表；\n如果联系人有多个号码，则返回所有号码的列表，如[号码1，号码2，号码3，…]",
    contactAvatar: "头像",
    contactAvatarTooltip: "字符串类型，返回选择的联系人的头像链接，可以嵌入图片框的设置图片积木中使用。如果没有头像则为空。",
    pickContact: "进行选择",
    onContactPickerSelected: "完成选择"
  }
}
export { r }
